<template>
    <div>
        <button
            type="button"
            :class="`btn-${dangerButtonSize} ${buttonClasses}`"
            class="btn btn-link text-accent-yellow"
            @click="$modal.show(modalName)"
        >
            <slot />
        </button>

        <form-modal
            :name="modalName"
            :primary-button-text="primaryButtonText"
            :title="title"
            :redirect-to="redirectTo"
            :method="method"
            :action="action"
        >
            <slot name="modal-content" />
        </form-modal>
    </div>
</template>
<script>
    import DangerButton from '../Atlantis/DangerButton';

    export default {
        extends: DangerButton,
    };
</script>